import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";

import CancelledBookings from '../Reports/Flight/CancelledBookings';
import AllTransactionsReport from '../Reports/Flight/AllTransactions';
import SaleSummaryReport from '../Reports/Flight/SaleSummary';
import UnflownTicketReport from '../Reports/Flight/UnflownTicket';

//Reservation
import ReservationFligthTransactions from '../Reservations/Flight/AllTransactions';
import ReservationTransactionDetails from '../Reservations/Flight/TransactionDetails';
import ReservationBusTransactions from '../Reservations/Bus/AllTransactions';
import ReservationCabTransactions from '../Reservations/Cab/AllTransactions';
import ReservationHotelTransactions from '../Reservations/Hotel/AllTransactions';
import ReservationTrainTransactions from '../Reservations/Train/AllTransactions';
import ReservationVisaTransactions from '../Reservations/Visa/AllTransactions';
import ReservationForexTransactions from '../Reservations/Forex/AllTransactions';
import ReservationInsuranceTransactions from '../Reservations/Insurance/AllTransactions';

import Home from '../External/Home';
import About from '../External/About';
import Contact from '../External/Contact';
import PrivacyPolicy from '../External/PrivacyPolicy';
import TermsofService from '../External/TermsofService';
import PaymentSecurity from '../External/PaymentSecurity';


import Flight from '../Products/Flight/Flight';
import Result from '../Products/Flight/Result';
import MultiCity from '../Products/Flight/MultiCityResult';

import Booking from '../Products/Flight/Booking';
import Dashboard from '../Dashboard/Dashboard';
import MyBooking from '../Dashboard/MyBooking';
import BookingDetails from '../Dashboard/BookingDetails';

import Hotel from '../Products/Hotel/Hotel';
import Results from '../Products/Hotel/Results';
import Availability from '../Products/Hotel/Availability';
import HotelDetail from '../Products/Hotel/HotelDetail';
import HotelBooking from '../Products/Hotel/HotelBooking';
import CheckOut from '../Products/Hotel/CheckOut';

import Bus from '../Products/Bus/Bus';
import Cabs from '../Products/Cabs/Cabs';
import Visa from '../Products/Visa/Visa';
import Forex from '../Products/Forex/Forex';
import Insurance from '../Products/Insurance/Insurance';
import Rail from '../Products/Rail/Rail';

import AgentDetails from '../Identity/AgentDetails';
import Thankyou from '../Products/Flight/Thankyou';

import Settings from '../Settings/Settings';
import ManageMarkup from '../Settings/ManageMarkup';
import UserAdmin from '../Settings/UserAdmin';
import Myprofile from '../Settings/Myprofile';
import ChangePassword from '../Settings/ChangePassword';

import CustomerInvoice from '../Reservations/Flight/CustomerInvoice';
import AgencyInvoice from '../Reservations/Flight/AgencyInvoice';
import ReSchedule from '../Reservations/Flight/ReSchedule';
import CancellationBooking from '../Reservations/Flight/CancellationBooking';
import PrintInvoice from '../Reservations/Flight/PrintInvoice';
import Approval from '../Dashboard/Approval';
import ApprovalDetail from '../Dashboard/ApprovalDetail';

import PersonalInformation from '../MyProfile/PersonalInformation';
import OrganizationProfile from '../MyProfile/OrganizationProfile';
import ContactDetails from '../MyProfile/ContactDetails';
import Documents from '../MyProfile/Documents';
import Preferences from '../MyProfile/Preferences';
import ReportingParameters from '../MyProfile/ReportingParameters';



import HdfcPaymentResponse from '../Payment/HdfcPaymentResponse';
const Layout = () => {

  return (
    <>
      {/* HEADER can be here */}

      <Routes>

        {/* INTERNAL LOGGED-IN ROUTES */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsofService />} />
        <Route path="/payment-security" element={<PaymentSecurity />} />

        <Route path="/flight" element={<Flight />} />
        <Route path="/flight/result" element={<Result />} />
        <Route path="/flight/multicity" element={<MultiCity />} />
        <Route path="/flight/booking" element={<Booking />} />
       
        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/mybooking" element={<MyBooking />} />
        <Route path="/dashboard/bookingDetails" element={<BookingDetails />} />
        <Route path="/dashboard/approval" element={<Approval />} />
        <Route path="/dashboard/approval/Approval-detail" element={<ApprovalDetail />} />


        {/* My Profile */}
        <Route path="/my-profile/personal-information" element={<PersonalInformation />} />
        <Route path="/my-profile/organization-profile" element={<OrganizationProfile />} />
        <Route path="/my-profile/contact-details" element={<ContactDetails />} />
        <Route path="/my-profile/documents" element={<Documents />} />
        <Route path="/my-profile/preferences" element={<Preferences />} />
        <Route path="/my-profile/reporting-parameters" element={<ReportingParameters />} />

        {/* Hotel */}
        <Route path="/hotel" element={<Hotel />} />
        <Route path="/hotel/result" element={<Results />} />
        <Route path="/availability" element={<Availability />} />
        <Route path="/hotel/hoteldetail" element={<HotelDetail />} />
        <Route path="/hotel/hotelbooking" element={<HotelBooking />} />
        <Route path="/hotel/checkout" element={<CheckOut />} />

        {/* Others */}
        <Route path="/bus" element={<Bus />} />
        <Route path="/cabs" element={<Cabs />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/forex" element={<Forex />} />
        <Route path="/insurance" element={<Insurance />} />
        <Route path="/rail" element={<Rail />} />

        {/* Reports */}
        <Route path="/reports/flight/alltransactions" element={<AllTransactionsReport />} />
        <Route path="/reports/flight/cancelledbookings" element={<CancelledBookings />} />
        <Route path="/reports/flight/salesummary" element={<SaleSummaryReport />} />
        <Route path="/reports/flight/unflownticket" element={<UnflownTicketReport />} />

        {/* Reservations */}
        <Route path="/reservations/flight/alltransactions" element={<ReservationFligthTransactions />} />
        <Route path="/reservations/flight/transactiondetails" element={<ReservationTransactionDetails />} />
        <Route path="/reservations/flight/customerinvoice" element={<CustomerInvoice />} />
        <Route path="/reservations/flight/agencyinvoice" element={<AgencyInvoice />} />
        <Route path="/reservations/flight/ReSchedule" element={<ReSchedule />} />
        <Route path="/reservations/flight/CancellationBooking" element={<CancellationBooking />} />
        <Route path="/reservations/flight/PrintInvoice" element={<PrintInvoice />} />
        <Route path="/reservations/bus/alltransactions" element={<ReservationBusTransactions />} />
        <Route path="/reservations/cab/alltransactions" element={<ReservationCabTransactions />} />
        <Route path="/reservations/hotel/alltransactions" element={<ReservationHotelTransactions />} />
        <Route path="/reservations/train/alltransactions" element={<ReservationTrainTransactions />} />
        <Route path="/reservations/visa/alltransactions" element={<ReservationVisaTransactions />} />
        <Route path="/reservations/forex/alltransactions" element={<ReservationForexTransactions />} />
        <Route path="/reservations/insurance/alltransactions" element={<ReservationInsuranceTransactions />} />

        {/* Settings */}
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/managemarkup" element={<ManageMarkup />} />
        <Route path="/settings/useradmin" element={<UserAdmin />} />
        <Route path="/settings/myprofile" element={<Myprofile />} />
        <Route path="/settings/changepassword" element={<ChangePassword />} />

        <Route path="/thankyou" element={<Thankyou />} />
        <Route path="/agent-details" element={<AgentDetails />} />

        <Route path="/HdfcPaymentResponse" element={<HdfcPaymentResponse />} />

      </Routes>

      {/* FOOTER can be here */}

    </>
  );
};

export default Layout;
